import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    background: ${props => props.bodyBgColor || '#ffffff'}
    margin: 0;
    text-rendering: optimizeLegibility;
    letter-spacing: 0.3px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: #10abe2;
    text-decoration: none;
  }
`;

export default GlobalStyle;
